import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { routePaths } from 'global/routePaths';
import { useCompanyInfo } from 'store/useUserStore';

const Employees: React.FC<unknown> = () => {
  const companyInfo = useCompanyInfo();

  if (!companyInfo?.evvSetting?.has_evv) return <Navigate to={routePaths.dashboard} replace />;

  return (
    <Box mx={{ base: 0, sm: 4, md: 6 }} my={{ base: 4, md: 6 }} minHeight="100%" p="4" bg="white" borderRadius="lg">
      <Outlet />
    </Box>
  );
};

export default Employees;
